import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'src/app/models/message';
import { PersonService } from 'src/app/services/person.service';
import { RolesService } from 'src/app/services/roles.service';
import { UserTeamService } from 'src/app/services/survey/user-team.service';
import { UserRoleService } from 'src/app/services/user-role.service';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-admuser-form',
  templateUrl: './admuser-form.component.html',
  styleUrl: './admuser-form.component.scss'
})
export class AdmuserFormComponent implements OnInit {

  formUsr: FormGroup;

  user: any = null;
  edit: boolean = false;

  roles: any;

  msg: Message = null;

  constructor(
    private usersService: UsersService,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private rolesService: RolesService,
    private personService: PersonService,
    private userRoleService: UserRoleService,
    private userTeamService: UserTeamService
  ) {
    this.createForm();
    this.getRoles();
    this.loadInfoToEdit();
  }

  ngOnInit() {

  }

  createForm() {
    this.formUsr = this.fb.group({
      id: [null],
      name: [],
      lastname: [],
      surname: [],
      idrol: [null],
      idperson: [null],
      email: ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]],
      pass: [''],
      isActive: [],
    })
  }

  loadData() {
    this.formUsr.reset(this.user);
  }

  getRoles() {
    this.rolesService.getRoles().subscribe({
      next: res => {
        this.roles = res['data'];
      },
      error: err => {
        this.msg = err;
      }
    });
  }

  save() {
    if (this.formUsr.invalid) {
      return Object.values(this.formUsr.controls).forEach(
        control => {
          if (control instanceof FormGroup) {
            Object.values(control.controls).forEach(
              control => control.markAsTouched()
            );
          } else {
            control.markAsTouched();
          }
        });
    } else {
      this.edit ? this.update(this.formUsr.value.id, this.formUsr.value) : this.create(this.formUsr.value);
    }
  }

  persona = { id: 0, name: '', lastname: '', surname: '', email1: '' };
  usuario = { idperson: 0, email: '', pass: '', isActive: false };
  usuario_rol = { userId: 0, roleId: 0, isActive: false };
  usuario_team = { iduser: 0, idteam: 0, isActive: false };

  create(user: any) {

    this.persona.name = user.name;
    this.persona.lastname = user.lastname;
    this.persona.surname = user.surname;
    this.persona.email1 = user.email;

    this.personService.create(this.persona).subscribe(

      res => {
        this.usuario.idperson = res['data'].id;
        this.usuario.email = user.email;
        this.usuario.pass = user.pass;
        this.usersService.createUser(this.usuario).subscribe(
          res => {

            this.usuario_rol.userId = res['data'].id;
            this.usuario_rol.roleId = (user.idrol) * 1
            this.usuario_rol.isActive = user.isActive;
            this.userRoleService.create(this.usuario_rol).subscribe(
              res => {
                this.usuario_team.idteam = 1;
                this.usuario_team.iduser = this.usuario_rol.userId;
                this.usuario_team.isActive = user.isActive;

                this.userTeamService.create(this.usuario_team).subscribe(
                  res => {

                  },
                  err => {
                    console.error(err)
                  }
                )

                alert(res['message']);

              }, err => {
                console.error(err)
              }
            );

          },
          err => {
            console.error(err)
          }
        )
      },
      err => {
        console.error(err)
      }
    );
    this.limpiarCampos();
  }

  userTemp = {}

  loadInfoToEdit() {
    const params = this.activedRoute.snapshot.params['id'];
    if (params) {
      this.usersService.getDataOnePerson(params).subscribe({
        next: res => {
          //Recibimos el Json e importamos a la variable local user atravez de useTemp para cargar el formulario
          console.log(res['data']);

          this.userTemp['id'] = res['data'].id;
          this.userTemp['email'] = res['data'].email;
          this.userTemp['isActive'] = res['data'].isActive;
          this.userTemp['idperson'] = res['data']['person'].id;
          this.userTemp['name'] = res['data']['person'].name;
          this.userTemp['lastname'] = res['data']['person'].lastname;
          this.userTemp['surname'] = res['data']['person'].surname;
          this.userTemp['idrol'] = ((res['data'])['roles'])[0].id

          this.user = this.userTemp;
          this.loadData();
          this.edit = true;
        },
        error: err => {
          this.msg = err;
        }
      })
    }
  }

  update(id: string, user: any) {

    this.persona.id = user.idperson;
    this.persona.name = user.name;
    this.persona.lastname = user.lastname;
    this.persona.surname = user.surname;
    this.persona.email1 = user.email;
    this.personService.update(this.persona).subscribe({
      next: res => {
        this.usuario.email = user.email;
        this.usuario.pass = user.pass;
        this.usuario.isActive = user.isActive;
        this.usersService.updateUser(id, this.usuario).subscribe({
          next: res => {
            this.usuario_rol.roleId = (user.idrol) * 1;
            this.usuario_rol.userId = user.id;
            this.userRoleService.update(this.usuario_rol).subscribe({
              next: res => {
                alert(res['message']);
              },
              error: err => {
                console.error(err)
              }
            });

          },
          error: err => {
            console.error(err)
          }
        })
      },
      error: err => {
        console.error(err)
      }
    });
  }

  campoNoValido(campo: string) {
    return this.formUsr.get(campo).invalid && this.formUsr.get(campo).touched;
  }

  limpiarCampos() {
    this.formUsr.reset();
  }

}



